import Icon from "@Components/Icon";
import Modal from "@Components/Modal";
import PickupPoint from "@Components/PickupPoint";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import Button from "../../overrides/venia-ui/components/Button";
import classes from "../BookTable/BookForm/bookTableForm.module.scss";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { AddressAutocompleteNoForm } from "@Components/AddressAutocomplete/addressAutocompleteNoForm";
import { getFilteredSortedStores } from "@Src_main/utils/storeConfigs";
import loadGmaps from "@Src_main/utils/GMapsJSImport";
import { shouldAskSwissRedirect, getSwissRedirectUrl } from "@Src_main/utils/swissRedirect";
const StoreBookFormModal = _ref => {
  let {
    setSelectedStore,
    isModalSelectionOpen,
    setIsModalSelectionOpen,
    allStores,
    showStoreHours,
    enableSwissOrderRedirect = false
  } = _ref;
  const {
    isMobile
  } = useWindowSize();
  const {
    formatMessage
  } = useIntl();
  const [choosedPosition, setChoosedPosition] = useState(null);
  const [isGeolocation, setIsGeolocation] = useState(false);
  const addressSetter = useRef();
  const [storesSorted, setStoresSorted] = useState([]);
  const [isSwissRedirectModalOpen, setIsSwissRedirectModalOpen] = useState(false);
  const [pendingSelectedStore, setPendingSelectedStore] = useState(null);
  const orderPath = formatMessage({
    id: "url.key.order"
  });
  const orderFromRestaurantPath = formatMessage({
    id: "url.key.order.from.restaurant"
  });
  const bookPath = formatMessage({
    id: "url.key.book.a.table"
  });
  const bookFromRestaurantPath = formatMessage({
    id: "url.key.book.a.table.from.restaurant"
  });
  const routePaths = {
    orderPath,
    orderFromRestaurantPath,
    bookPath,
    bookFromRestaurantPath
  };
  const handleValueSetter = setter => {
    addressSetter.current = setter;
  };
  const handleSelectedAddressDetails = details => {
    if (details) {
      setChoosedPosition({
        latitude: details.geometry.location.lat(),
        longitude: details.geometry.location.lng()
      });
    } else setChoosedPosition(null);
  };
  useEffect(() => {
    if (choosedPosition && allStores) {
      const sortedStores = getFilteredSortedStores(allStores, choosedPosition);
      setStoresSorted(sortedStores);
    } else if (allStores) {
      const sortedStores = allStores;
      setStoresSorted(sortedStores);
    }
  }, [choosedPosition, allStores]);
  const checkPosition = () => {
    if (window.navigator.geolocation) {
      setIsGeolocation(false);
      window.navigator.geolocation.getCurrentPosition(position => {
        var _position$coords, _position$coords2;
        if (position !== null && position !== void 0 && (_position$coords = position.coords) !== null && _position$coords !== void 0 && _position$coords.latitude && position !== null && position !== void 0 && (_position$coords2 = position.coords) !== null && _position$coords2 !== void 0 && _position$coords2.longitude) {
          setIsGeolocation(true);
          setChoosedPosition({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
          new google.maps.Geocoder().geocode({
            latLng: new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK && addressSetter !== null && addressSetter !== void 0 && addressSetter.current) {
              addressSetter.current(results[0].formatted_address);
            }
          });
        }
      }, () => {
        setIsGeolocation(false);
      });
    }
  };
  const geolocation = /*#__PURE__*/React.createElement("button", {
    className: "geolocator uk-padding-remove ".concat(classes.geolocator),
    onClick: checkPosition
  }, isGeolocation ? /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "white"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "black",
    header: true
  }));
  useEffect(() => {
    loadGmaps();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    id: "modal-store-selection",
    nameClass: "modal-store-selection",
    modalDialogClass: "".concat(isMobile ? "section-rounded uk-position-bottom " : "uk-position-center uk-border-rounded  "),
    animation: "".concat(isMobile ? "uk-animation-slide-bottom" : "uk-animation-scale-up"),
    modalCloseOutside: true,
    isOpen: isModalSelectionOpen,
    onClose: () => {
      setIsModalSelectionOpen(false);
    }
  }, storesSorted.length ? /*#__PURE__*/React.createElement("div", {
    className: "uk-overflow-auto uk-height-xlarge"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "uk-margin-top-small uk-align-center uk-padding uk-margin-bottom uk-padding-remove-vertical uk-margin-small-top uk-text-uppercase uk-text-center"
  }, formatMessage({
    id: "book.table.store.selection"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-padding uk-margin-bottom uk-padding-remove-vertical uk-flex uk-flex-center uk-text-center search"
  }, /*#__PURE__*/React.createElement(AddressAutocompleteNoForm, {
    field: "address",
    fullAddress: true,
    before: /*#__PURE__*/React.createElement(Icon, {
      name: "icon-position",
      color: "miscusi-red"
    }),
    getValueSetter: handleValueSetter,
    getSelectedAddressDetails: handleSelectedAddressDetails,
    onChange: e => e.target.value.trim() === "" ? handleSelectedAddressDetails(null) : null
  }), geolocation), /*#__PURE__*/React.createElement("div", {
    className: "uk-padding uk-overflow-auto uk-height-large uk-flex-nowrap uk-flex uk-grid uk-grid-small uk-flex-column",
    style: {
      msOverflowStyle: "none",
      scrollbarWidth: "thin"
    },
    "data-uk-grid": true
  }, storesSorted.map(store => /*#__PURE__*/React.createElement("div", {
    key: store.ls_store_id
  }, /*#__PURE__*/React.createElement(PickupPoint, {
    selectable: true,
    onSelect: () => {
      setIsModalSelectionOpen(false);
      if (shouldAskSwissRedirect(store, {
        enableSwissOrderRedirect
      })) {
        setPendingSelectedStore(store);
        setIsSwissRedirectModalOpen(true);
        return;
      }
      setSelectedStore(store);
    },
    store: store,
    choosedPosition: choosedPosition,
    showStoreHours: showStoreHours,
    showDetailModal: true
  }))))) : null), /*#__PURE__*/React.createElement(Modal, {
    id: "modal-swiss-store-redirect",
    nameClass: "modal-swiss-store-redirect",
    position: "uk-position-center",
    modalDialogClass: "uk-text-center section-full-rounded uk-padding-medium",
    animation: "uk-animation-scale-up",
    modalCloseOutside: true,
    isOpen: isSwissRedirectModalOpen,
    onClose: () => {
      setIsSwissRedirectModalOpen(false);
      setPendingSelectedStore(null);
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      textAlign: "center"
    }
  }, formatMessage({
    id: "store.redirect.swiss.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-bottom"
  }, formatMessage({
    id: "store.redirect.swiss.description"
  })), /*#__PURE__*/React.createElement(Button, {
    id: "storeRedirectSwissConfirm",
    onClick: () => {
      if (!pendingSelectedStore) {
        setIsSwissRedirectModalOpen(false);
        return;
      }
      const redirectUrl = getSwissRedirectUrl(pendingSelectedStore, routePaths);
      window.location.assign(redirectUrl);
    },
    color: "primary",
    fullScreen: true,
    type: "button"
  }, formatMessage({
    id: "store.redirect.swiss.confirm"
  }))));
};
export default StoreBookFormModal;